<template>
  <div :class="this.$store.state.ashen == 'false' ? 'hei':'bai'">
    <div v-show="this.$store.state.SqHone===false">
        <HelloWorld></HelloWorld>
    </div>
    <div v-show="this.$store.state.SqHone===true">
        <router-view name="shequs"></router-view> 
    </div>
  </div>
</template>
<script>
import HelloWorld from './components/index.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
 
  methods:{

  }
}
</script>

<style lang="scss">
  *{
    margin: 0;
    padding: 0;
    list-style: none;
    text-decoration: none;
    user-select: none;
  }
  // @font-face {

    
  //   font-family: YuanTi;
  //   src: url('./assets/GenJyuuGothic-Normal.ttf');
  // }
  .icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.el-message{
  margin-left: 125px;
}
</style>
